'use client';

import {SectionSeparatorSectionFieldsFragment} from '@generated/graphql';
import {FC} from 'react';
import {Container} from '@mui/material';
import {StyledHr} from './SectionSeparator.styles';

type SectionSeparatorProps = {
    section: SectionSeparatorSectionFieldsFragment;
};

export const SectionSeparator: FC<SectionSeparatorProps> = () => {
  return <Container maxWidth='mdlg'><StyledHr /></Container>;
};
